import React from 'react';

/** Centered empty / loading state (serif heading + muted line). */
export function LwEmpty({ title, children }: { title?: string; children?: React.ReactNode }) {
  return (
    <div className="empty">
      {title && <h3>{title}</h3>}
      {children && <p>{children}</p>}
    </div>
  );
}
